/**
 * description: 考核指标
 * author: bql
 * 2023/7/18 11:11
 */

import {NewviewOaBaseApi} from "./NewviewOaBaseApi";

export class DataPerformanceCheckApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'data-performance-check'
    }

}
 